import { NavKeys } from '@common-modules/dependencies/navigation/nav-keys.enum';
import { AppPermissionsSettings } from '@common-modules/shared/auth/services/app-permissions-settings';
import { WlmNavKeys } from './features/navigation/wlm-nav-keys';

const waterLossRoutePermissions = new Map<NavKeys, [string, string][]>([
  [WlmNavKeys.Home, []],
  [WlmNavKeys.LeakageCalculationModule, [['LeakageCalculationCrud', 'r']]],
  [WlmNavKeys.DistributionNetwork, [['WLMDistributionNetworkCrud', 'r']]],
  [WlmNavKeys.TransmissionNetwork, [['WLMTransmissionNetworkCrud', 'r']]],
  [WlmNavKeys.PressureManagementModule, [['WLMPressureManagementCrud', 'r']]],
  [WlmNavKeys.PressureMonitoring, [['WLMPressureMonitoringCrud', 'r']]],
  [WlmNavKeys.LeakageCalculationModule, [['LeakageCalculationCrud', 'r']]],
  [WlmNavKeys.DataVisualization, [['WLMDataVisualizationCrud', 'r']]],
  [WlmNavKeys.DataValidation, [['WLMDataValidationCrud', 'r']]],
  [WlmNavKeys.CustomerDetails, [['WLMCustomerDetailsCrud', 'r']]],

  [WlmNavKeys.AlcModule, [['ActiveLeakageControlCrud', 'r']]],
  [WlmNavKeys.Prioritisation, [['PrioritisationCrud', 'r']]],
  [
    WlmNavKeys.ActivityRaising,
    [
      ['ActivityRaisingCrud', 'r'],
      ['ActivityRaisingCrud', 'u'],
    ],
  ],
  [WlmNavKeys.Activities, [['ActivitiesCrud', 'r']]],
  [WlmNavKeys.Leaks, [['LeaksCrud', 'r']]],
  [WlmNavKeys.Campaigns, [['WLMCampaignCrud', 'r']]],

  [WlmNavKeys.WaterBalanceModule, [['WaterBalanceCrud', 'r']]],
  [WlmNavKeys.WaterBalance, [['WaterBalanceCrud', 'r']]],

  [WlmNavKeys.BiModule, [['WLMBusinessIntelligenceCrud', 'r']]],
  [WlmNavKeys.Bi, [['WLMBusinessIntelligenceCrud', 'r']]],
  [WlmNavKeys.BIHome, [['WLMBusinessIntelligenceCrud', 'r']]],

  [WlmNavKeys.DataAccessModule, [['DataAccessCrud', 'r']]],
  [WlmNavKeys.Map, [['WLMMapCrud', 'r']]],
  [WlmNavKeys.DataValidation, [['WLMDataValidationCrud', 'r']]],
  [WlmNavKeys.DataVisualization, [['WLMDataVisualizationCrud', 'r']]],
  [WlmNavKeys.LeakageReporting, [['WLMLeakageReportingCrud', 'r']]],
  [WlmNavKeys.CustomerDetails, [['WLMCustomerDetailsCrud', 'r']]],
  [WlmNavKeys.Schematics, [['WLMSchematicsCrud', 'r']]],

  [WlmNavKeys.MonitoringModule, [['MonitoringCrud', 'r']]],
  [WlmNavKeys.Notifications, [['WLMNotificationsCrud', 'r']]],

  [WlmNavKeys.ConfigurationModule, [['ConfigurationCrud', 'r']]],
  [WlmNavKeys.TelemetryPoints, [['WLMTelemetryPointsCrud', 'r']]],
  [WlmNavKeys.AlarmsConfiguration, [['WLMAlarmsCrud', 'r']]],
  [WlmNavKeys.AlarmsCreationTelemetry, [['WLMAlarmsCrud', 'c']]],
  [WlmNavKeys.AlarmsCreationAlgorithms, [['WLMAlarmsCrud', 'c']]],
  [WlmNavKeys.NetworkElementConfig, [['WLMNetworkCrud', 'r']]],
  [WlmNavKeys.NetworkElementDetails, [['WLMNetworkCrud', 'r']]],
  [WlmNavKeys.Algorithms, [['WLMAlgorithmsCrud', 'r']]],
  [WlmNavKeys.Hierarchy, [['WLMHierarchyCrud', 'r']]],
  [WlmNavKeys.UoM, [['WLMUnitsOfMeasurementCrud', 'r']]],
  [WlmNavKeys.Calendar, [['WLMCalendarsCrud', 'r']]],
  [WlmNavKeys.MergedZones, [['WLMMergedZonesCrud', 'r']]],

  [WlmNavKeys.AdministrationModule, [['WLMAdministrationCrud', 'r']]],
  [WlmNavKeys.Users, [['WLMAdministrationCrud', 'r']]],
  [WlmNavKeys.Groups, [['WLMAdministrationCrud', 'r']]],

  [WlmNavKeys.LogsModule, [['WLMLogCrud', 'r']]],
  [WlmNavKeys.LogsInterfaces, [['WLMInterfacesCrud', 'r']]],
  [WlmNavKeys.LogsSystem, [['WLMSystemCrud', 'r']]],
  [WlmNavKeys.Audits, [['WLMAuditsCrud', 'r']]],

  [WlmNavKeys.ValidationModule, [['WLMVEValidationCrud', 'r']]],
  [WlmNavKeys.RuleSets, [['WLMVEValidationCrud', 'r']]],
  [WlmNavKeys.VEGroups, [['WLMVEValidationCrud', 'r']]],
]);

const waterLossPermissionsHierarchy = new Map<WlmNavKeys, WlmNavKeys>([
  [WlmNavKeys.DistributionNetwork, WlmNavKeys.LeakageCalculationModule],
  [WlmNavKeys.TransmissionNetwork, WlmNavKeys.LeakageCalculationModule],
  [WlmNavKeys.PressureMonitoring, WlmNavKeys.PressureManagementModule],
  [WlmNavKeys.Prioritisation, WlmNavKeys.AlcModule],
  [WlmNavKeys.ActivityRaising, WlmNavKeys.AlcModule],
  [WlmNavKeys.Activities, WlmNavKeys.AlcModule],
  [WlmNavKeys.Leaks, WlmNavKeys.AlcModule],
  [WlmNavKeys.Campaigns, WlmNavKeys.AlcModule],
  [WlmNavKeys.WaterBalance, WlmNavKeys.WaterBalanceModule],
  [WlmNavKeys.Bi, WlmNavKeys.BiModule],
  [WlmNavKeys.Map, WlmNavKeys.DataAccessModule],
  [WlmNavKeys.DataValidation, WlmNavKeys.DataAccessModule],
  [WlmNavKeys.DataVisualization, WlmNavKeys.DataAccessModule],
  [WlmNavKeys.LeakageReporting, WlmNavKeys.DataAccessModule],
  [WlmNavKeys.CustomerDetails, WlmNavKeys.DataAccessModule],
  [WlmNavKeys.Schematics, WlmNavKeys.DataAccessModule],
  [WlmNavKeys.Notifications, WlmNavKeys.MonitoringModule],
  [WlmNavKeys.TelemetryPoints, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.AlarmsConfiguration, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.NetworkElementConfig, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.Algorithms, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.Hierarchy, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.UoM, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.Calendar, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.MergedZones, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.AlarmsCreationTelemetry, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.AlarmsCreationAlgorithms, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.NetworkElementDetails, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.Algorithms, WlmNavKeys.ConfigurationModule],
  [WlmNavKeys.Users, WlmNavKeys.AdministrationModule],
  [WlmNavKeys.Groups, WlmNavKeys.AdministrationModule],
  [WlmNavKeys.LogsInterfaces, WlmNavKeys.LogsModule],
  [WlmNavKeys.LogsSystem, WlmNavKeys.LogsModule],
  [WlmNavKeys.Audits, WlmNavKeys.LogsModule],
  [WlmNavKeys.RuleSets, WlmNavKeys.ValidationModule],
]);

export const waterLossAppPermissions: AppPermissionsSettings = {
  routePermissions: waterLossRoutePermissions,
  permissionsHierarchy: waterLossPermissionsHierarchy,
};
